import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { get } from 'lodash';
import { connect } from 'react-redux';
import SearchBarContainer from '../../../components/SearchBar/SearchBarContainer';
import { MY_BETS, NEW_BETS, navigationMapping } from '../../../consts/navigation';
import './BreadcrumbsBets.scss';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const BreadcrumbsBets = ({ recentNewBets, onSearchClick, tableName, isMobile, t, }) => {
  const renderNewBetsAlert = (recentNewBets && <div className="new-bets" />);
  return (
    <div className="main-area__header bets-breadcrumbs">
      { isMobile && <SearchBarContainer onSearchClick={onSearchClick} tableName={tableName} delay={600} /> }

      <div className="details__menu">
        <ul>
          <NavLink to={navigationMapping[MY_BETS].table_url}>{t('my_bets')}</NavLink>
          <NavLink to={navigationMapping[NEW_BETS].table_url}>
            <span>{t('new_bets')}</span>
            {renderNewBetsAlert}
          </NavLink>
        </ul>
      </div>

      { !isMobile && <SearchBarContainer onSearchClick={onSearchClick} tableName={tableName} delay={600} /> }

      <style jsx="true">{`
        .bets-breadcrumbs {
          display: flex;
          justify-content: space-between;
        }
      `}</style>
    </div>
  );
};

BreadcrumbsBets.propTypes = {
  onSearchClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  recentNewBets: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  tableName: PropTypes.string.isRequired,
};

BreadcrumbsBets.defaultProps = {
  isMobile: true,
}

const mapStateToProps = (state) => {
  return {
    isMobile: get(state, ['layout', 'isMobile']),
  };
};

export default compose(connect(mapStateToProps), withScopedTranslations('breadcrumbs.bets'))(BreadcrumbsBets);
